/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Pdfcraft_BestInputs */

const en_pc_alt_t_pdfcraft_best = /** @type {(inputs: Pc_Alt_T_Pdfcraft_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading, comments, forms, page organizing, combine and split, passwords and redaction, CLI and MCP`)
};

const zh_pc_alt_t_pdfcraft_best = /** @type {(inputs: Pc_Alt_T_Pdfcraft_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读、批注、表单、页面整理、合并与拆分、密码与涂黑、CLI 与 MCP`)
};

/**
* | output |
* | --- |
* | "Reading, comments, forms, page organizing, combine and split, passwords and redaction, CLI and MCP" |
*
* @param {Pc_Alt_T_Pdfcraft_BestInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_pdfcraft_best = /** @type {((inputs?: Pc_Alt_T_Pdfcraft_BestInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Pdfcraft_BestInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_pdfcraft_best(inputs)
	return zh_pc_alt_t_pdfcraft_best(inputs)
});
export { pc_alt_t_pdfcraft_best as "pc.alt.t.pdfcraft.best" }